import { IRenter } from "./renter.type";

export enum INDICATORS_STATUS {
  Ativo = "ativo",
  Inativo = "inativo",
  Bloqueado = "bloqueado",
  Indefinido = "indefinido",
  PendentePagamento = "pendente_pagamento",
  PagamentoEfetuado = "pagamento_efetuado",
  ambassador = "ambassador",
  rentalpoint = "rentalpoint",
  indicator = "indicator",
}

export type IndicatorsDataBank = {
  typeTransaction: string;
  tipoDeChave: string;
  chavePix: string;
};

export type Address = {
  zipcode: string;
  street: string;
  number?: string | number;
  complement?: string;
  city: string;
  state: string;
  district: string;
  latitude?: number; // Geolocalização, opcional
  longitude?: number; // Geolocalização, opcional
};

export type Observation = {
  text: string;
  date: string;
  author: string;
};

export type PayedIndicator = {
  createAtPayed: string;
  cpfFromIndicated: string;
  payed: string;
};

export type PayedUpload = {
  createAtPayed: Date;
  cpfFromIndicated: string;
  file: string;
};

export type IIndicators = {
  createdAt: string | number | Date;
  _id?: string;
  companyId: string;
  name: string;
  whatsapp: string;
  email: string;
  cpf: string;
  birthDate: string;
  dataBank: IndicatorsDataBank;
  address: Address;
  observations: Observation[];
  payedIndicator: PayedIndicator[];
  payedUpload: PayedUpload[];
  nameRentalPoint?: string;
  activeRentalPoint?: boolean;
  renters?: IRenter[];
  jurValidation: {
    status: boolean;
    validated: boolean;
    details?: string;
  }
  code: string;
  sdrEnable: boolean;
};

export type PendingItem = {
  companyId?: string;
  name: string;
  date: string;
  value: number;
  cpf?: string
};

export type IndicatorPending = {
  _id: string;
  name: string;
  companyId: string;
  email?: string;
  whatsapp?: string;
  cpf: string;
  createdAt: string;
  pendingCount: number;
  pendingItems: PendingItem[];
	dataBank: IndicatorsDataBank;
};

export type IndicatorType = {
  _id: string;
  name: string;
  pendencies: PendencyType[];
  status: INDICATORS_STATUS;
  updatedAt: string;
  createdAt: string;
};

export const emptyIndicator = (): IIndicators =>
({
  _id: "",
  companyId: "",
  name: "",
  whatsapp: "",
  email: "",
  cpf: "",
  birthDate: "",
  dataBank: {
    typeTransaction: "Pix",
    tipoDeChave: "",
    chavePix: "",
  },
  address: {
    zipcode: "",
    street: "",
    number: 0,
    complement: "",
    city: "",
    state: "",
    district: "",
    latitude: 0,
    longitude: 0,
  },
  createdAt: "",
  observations: [],
  payedIndicator: [
    {
      createAtPayed: "",
      cpfFromIndicated: "",
      payed: "",
    },
  ],
  payedUpload: [],
  jurValidation: {
    status: false,
    validated: false,
    details: ""
  },
  code: "",
  sdrEnable: true
} as IIndicators);

export type PendencyType = {
  key: string;
  message: string;
  entityErrors: [
    {
      message: string;
      path: string[];
    }
  ];
};
